export const AUTH_USER_EMAIL_KEY = 'app.email';
export const AUTH_USER_ID_KEY = 'app.user.id';
export const AUTH_USER_EMAIL_CONFIRMED_KEY = 'app.email_confirmed';
export const AUTH_SESSION = 'app.session.id';
export const APP_PORTFOLIO_ID = 'app.portfolio.id';
export const APP_LANDING = '/m/clients';
export const APP_ACTION_ITEMS = '/a/action-items';
export const APP_LOGIN_PATH = '/a/login';
export const APP_LOGOUT_PATH = '/a/logout';
export const APP_CONFIRM_EMAIL_PATH = '/a/confirm-email';
export const APP_RESET_PASSWORD_PATH = '/a/reset-password';

export type EsignDocument = {
    template: EsignTemplate,
    fields: EsignField[],
    name: string,
    status: string
}


export type EsignTemplate = {
    url: string,
    fields: EsignField[],
    name: string
}

export type EsignField = {
    id: string,
    name: string,
    type: string,
    x: number,
    y: number,
    width: number,
    height?: number,
    page: number,
    value: string,
    disabled: boolean,
    backgroundColor:string,
    border:string,
    required: boolean,
    _uuid?:string,
    uuid:string,
    isDeleted?: boolean,
    tabIndex: number,
    fontSize: string
}

export type Field = {
    id: string,
    name: string,
    type: string,
    x: number,
    y: number,
    width: number,
    page: number,
    value: string,
    disabled: boolean
}

export type FileShare = {
    uuid: string
}

export type Client = {
    id: string,
    uuid: string,
    documents: ClientDocument[],
    legacyDocuments: LegacyDocument[],
    legacyNotes: LegacyNote[],
    address: {
        addressLine1: string,
        addressLine2: string,
        city: string,
        state: string,
        zip: string,
        uuid?: string
    },
    firstName: string,
    lastName: string,
    socialsecurityNumber: string,
    driverslicenseNumber: string,
    driverslicenseState: string,
    dateofBirth: string,
    telephoneNumber: string,
    email: string,
    dateTimeofAssessment: string

    totalHoursAttended: string,
    recommendedHours: string,
    absences: string,
    balance: number,
    transactions: Transaction[],
    disabled: boolean,
    attendances: Attendance[],
    payments: Payment[],
    clientDiagnosis: string,
    drugTestDueDate: string
}

export type Attendance = {
    attended: boolean,
    signed: boolean,
    signedTimestamp: boolean,
    therapySession: TherapySession,
    document: {
        uuid: string
    }
}

export type Transaction = {
    amount: number,
    description: string,
    uuid: string,
    type: string
    createdAt: string
}

export type Charge = {
    amount: number,
    description: string,
    uuid: string,
    chargeDate: string
}

export type Payment = {
    amount: number,
    description: string,
    uuid: string,
    paymentDate: string
    method: string
    status: string,
    creditCard?: CreditCard
}

export type CreditCard = {
    creditCardNumber: string;
    cvv: string;
    expirationMonth: string;
    expirationYear: string;
    zipCode: string;
    uuid: string;
}

export type TherapySession = {
    therapist: AppUser,
    clients?: Client[],
    status: string,
    date: string,
    startTime: string,
    endTime: string,
    uuid?: string,
    noteUuid?: string
}

export type FormRegex = {
    expression: RegExp,
    helpText: string
}


export enum BootstrapValidateClass {
    isvalid = "is-valid", isinvalid = "is-invalid", unvalidated = ""
}


export type FormElementValidation = {
    id: string,
    validate: ValidateElementFunction,
    regex: FormRegex,
    required: boolean
}



export type ValidateElementFunction = (value: string, required: boolean, validation: RegExp) => boolean;

export const formInputValidate: ValidateElementFunction = (value: string, required: boolean, validation: RegExp): boolean => {
    if (required) {
        if (value && value.match(validation)) {
            return true;
        }
        return false;
    } else {
        if ((value && value.length === 0) || !value) {
            return true;
        }
        if (value && value.match(validation)) {
            return true;
        }
        return false;
    }
}

export const formSelectValidate: ValidateElementFunction = (value: string, required: boolean, validation: RegExp): boolean => {
    if (value && value.match(validation)) {
        return true;
    }
    return false;
}

export type Role = {
    name: string
}

export type Template = {
    url: string,
    uuid: string,
    name: string,
    tag: string
}

export type Document = {
    template: Template
    uuid: string,
}

export type EsignProfile = {
    name: string,
    uuid: string,
    appLocation: string
}

export type ClientDocument = {
    uuid: string,
    name: string,
    type: string,
    url: string,
    description: string,
    status: string,
    createdAt: string
}

export type LegacyDocument = {
    name: string,
    id: number,
    createdAt: string,
    pages: LegacyDocumentPage[]
}

export type LegacyDocumentPage = {
    number: number,
    width: number,
    height: number,
    imageData: string,
    fields: LegacyDocumentField[]
}

export type LegacyDocumentField = {
    id: number,
    name: string,
    formNumber: number,
    page: number,
    x: number,
    y: number,
    fontSize: number,
    value: string,
    type: string
}

export type AppUser = {
    email?: string,
    username?: string,
    firstName: string,
    lastName: string,
    role?: string,
    actions?: Action[],
    uuid: string
}

export type Key = {
    uuid: string,
    expireAt: string
}

export type Action = {
    code: string,
    description: string
}

export type MenuItem = {
    label: string,
    path: string,
    menuItems: MenuItem[],
    icon: string,
    weight: number
}

export type Feature = {
    name: string
}

export type FileResponse = {
    name: string,
    uuid: string,
    size: number
}

export type Deployment = {
    name: string,
    uuid?: string,
    profile: string,
    createdAt?: string
    artifacts: string [],
    container?: Container
}

export type Container = {
    Id: string,
    Image: string,
    Command: string,
    Created: string
    Names: string[],
    State: string,
    Status: string,
    Labels: Object,
    Ports: {
        PrivatePort: string,
        Type: string
    }[],
    NetworkSettings: {
        Networks: {
            bridge: {
                NetworkID: string,
                Gateway: string,
                IPAddress: string
            }
        }
    }
}


export type LegacyNote = {
    id: number,
    clientId: number,
    hours: number,
    note: string,
    additionalNote: string,
    sessionDate: string,
    sessionTime: string,
    sessionTopic: string,
    sessionStatus: string,
    sessionNotes: string,
    sessionProgress: string,
    sessionActivity: string,
    sessionContact: string
}
